<script lang="ts">
    import type { UserOrganizationRoleData } from "@anyways-open/identity-api-client";
    import { Link } from "svelte-navigator";
    import { Button } from "sveltestrap";

    export let data: UserOrganizationRoleData;
</script>

<div class="list-group-item">
    <div class="row align-items-center">
        <div class="col-6">
            <p class="mb-0">{data.organization.name}</p>

            <p class="d-block small text-truncate text-gray-700">
                {data.organization.description ?? ""}
            </p>
        </div>
        <div class="col-auto ms-auto">
            {#if data.role.key == "admin"}
                <Link
                    class="btn btn-xs btn-primary"
                    to="/settings/organizations/{data.organization.id}">
                    Manage
                </Link>
            {:else}
                {data.role.name}
            {/if}
        </div>
        <div class="col-auto">
            <button
                class="btn btn-xs btn-primary">
                Leave
            </button>
        </div>
    </div>
</div>
